import React, { useState } from 'react'
import { Button } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashCan, faLeaf } from '@fortawesome/free-solid-svg-icons'
import { Store } from '../../../../utils/toast'
import {
  useGetIngredientsQuery,
  useDeleteIngredientMutation,
} from '../../../../store/api/ingredientsApi'
import { IIngredient } from '../../../../types/ingredients'
import IngredientsModal from './ingredients-modal/IngredientsModal'
import ConfirmDialog from '../../../../components/confirm-dialog/ConfirmDialog'
import './IngredientsPage.scss'

const c = 'ingredients-page'

const IngredientsPage = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [ingredient, setIngredient] = useState<IIngredient>()
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null)
  const { data: ingredients = [] } = useGetIngredientsQuery()
  const [deleteIngredient] = useDeleteIngredientMutation()

  function handleDelete(ingredientId: string) {
    deleteIngredient(ingredientId)
      .unwrap()
      .then(() => {
        Store.addNotification({
          title: 'SUCCESS',
          message: 'Sters cu succes!',
          container: 'top-center',
          type: 'success',
          insert: 'top',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: { duration: 1000, onScreen: true },
        })
      })
  }

  function handleEdit(ingredient: IIngredient) {
    setIsOpenEdit(true)
    setIngredient(ingredient)
  }

  const ingredientToDelete = ingredients.find((i) => i._id === confirmDeleteId)

  return (
    <div className={c}>
      <div className={`${c}__header`}>
        <div className={`${c}__header-title`}>Ingrediente</div>
        <Button
          variant='contained'
          onClick={() => setIsOpen(true)}
          sx={{
            backgroundColor: 'var(--color-primary)',
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
          }}
        >
          + Adaugă
        </Button>
      </div>

      <div className={`${c}__list`}>
        {ingredients?.map((ingredient) => (
          <div key={ingredient._id} className={`${c}__list-item`}>
            <div className={`${c}__list-item-icon`}>
              <FontAwesomeIcon icon={faLeaf} />
            </div>
            <div className={`${c}__list-item-info`}>
              <div className={`${c}__list-item-info-label`}>
                {ingredient.label}
              </div>
              <div className={`${c}__list-item-info-tags`}>
                <span className={`${c}__list-item-info-tags-tag`}>
                  {ingredient.price_gram} lei/gram
                </span>
                <span className={`${c}__list-item-info-tags-tag`}>
                  {ingredient.price_piece} lei/bucată
                </span>
                <span className={`${c}__list-item-info-tags-tag customer`}>
                  Client: {ingredient.customer_price ?? 0} lei
                </span>
              </div>
            </div>
            <div className={`${c}__list-item-actions`}>
              <button
                className={`${c}__list-item-actions-btn edit`}
                onClick={() => handleEdit(ingredient)}
                title='Editează'
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                className={`${c}__list-item-actions-btn delete`}
                onClick={() => setConfirmDeleteId(ingredient._id)}
                title='Șterge'
              >
                <FontAwesomeIcon icon={faTrashCan} />
              </button>
            </div>
          </div>
        ))}
      </div>

      <ConfirmDialog
        open={!!confirmDeleteId}
        title='Șterge ingredient'
        message={`Ești sigur că vrei să ștergi "${ingredientToDelete?.label}"?`}
        onConfirm={() => {
          if (confirmDeleteId) handleDelete(confirmDeleteId)
          setConfirmDeleteId(null)
        }}
        onCancel={() => setConfirmDeleteId(null)}
      />

      <IngredientsModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <IngredientsModal
        isOpen={isOpenEdit}
        setIsOpen={setIsOpenEdit}
        data={ingredient}
      />
    </div>
  )
}

export default IngredientsPage
